import React, { useState } from 'react';

const WithdrawalForm = ({
  minAmount = 100,
  maxAmount = 0,
  pending = null,
  onSubmit,
  submitLabel = 'Request Withdrawal',
}) => {
  const [form, setForm] = useState({
    amount: '',
    paymentMethod: 'bank_transfer',
    bankDetails: {
      accountHolderName: '',
      accountNumber: '',
      ifscCode: '',
      bankName: ''
    }
  });
  const [errors, setErrors] = useState({});

  const handleChange = (path, value) => {
    if (path.startsWith('bankDetails.')) {
      const key = path.split('.')[1];
      setForm(prev => ({ ...prev, bankDetails: { ...prev.bankDetails, [key]: value } }));
    } else {
      setForm(prev => ({ ...prev, [path]: value }));
    }
  };

  const validate = () => {
    const errs = {};
    const amt = Number(form.amount);
    if (!form.amount) errs.amount = 'Amount is required';
    else if (isNaN(amt) || amt < minAmount) errs.amount = `Minimum withdrawal is ₹${minAmount}`;
    else if (maxAmount && amt > maxAmount) errs.amount = 'Amount exceeds available';

    if (!form.bankDetails.accountHolderName) errs.accountHolderName = 'Account holder name is required';
    if (!form.bankDetails.accountNumber) errs.accountNumber = 'Account number is required';
    if (!form.bankDetails.ifscCode) errs.ifscCode = 'IFSC is required';
    if (!form.bankDetails.bankName) errs.bankName = 'Bank name is required';

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    onSubmit && onSubmit({ amount: Number(form.amount), bankDetails: form.bankDetails });
  };

  const formatCurrency = (n) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(n || 0);

  return (
    <div>
      {pending && pending.amount > 0 && (
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
          <p className="font-medium text-yellow-800">Pending Withdrawal</p>
          <p className="text-sm text-yellow-700">You have a pending withdrawal of {formatCurrency(pending.amount)}.</p>
        </div>
      )}

      <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-md p-6 space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Amount</label>
          <input
            type="number"
            value={form.amount}
            onChange={(e) => handleChange('amount', e.target.value)}
            className="w-full border rounded-md px-3 py-2"
            min={minAmount}
            max={maxAmount || undefined}
            placeholder={`Min ${formatCurrency(minAmount)}`}
          />
          {errors.amount && <p className="text-xs text-red-600 mt-1">{errors.amount}</p>}
          {maxAmount ? (
            <p className="text-xs text-gray-500 mt-1">Available: {formatCurrency(maxAmount)}</p>
          ) : null}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Account Holder Name</label>
            <input
              type="text"
              value={form.bankDetails.accountHolderName}
              onChange={(e) => handleChange('bankDetails.accountHolderName', e.target.value)}
              className="w-full border rounded-md px-3 py-2"
            />
            {errors.accountHolderName && <p className="text-xs text-red-600 mt-1">{errors.accountHolderName}</p>}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Account Number</label>
            <input
              type="text"
              value={form.bankDetails.accountNumber}
              onChange={(e) => handleChange('bankDetails.accountNumber', e.target.value)}
              className="w-full border rounded-md px-3 py-2"
            />
            {errors.accountNumber && <p className="text-xs text-red-600 mt-1">{errors.accountNumber}</p>}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">IFSC Code</label>
            <input
              type="text"
              value={form.bankDetails.ifscCode}
              onChange={(e) => handleChange('bankDetails.ifscCode', e.target.value.toUpperCase())}
              className="w-full border rounded-md px-3 py-2"
            />
            {errors.ifscCode && <p className="text-xs text-red-600 mt-1">{errors.ifscCode}</p>}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Bank Name</label>
            <input
              type="text"
              value={form.bankDetails.bankName}
              onChange={(e) => handleChange('bankDetails.bankName', e.target.value)}
              className="w-full border rounded-md px-3 py-2"
            />
            {errors.bankName && <p className="text-xs text-red-600 mt-1">{errors.bankName}</p>}
          </div>
        </div>

        <div className="pt-2">
          <button type="submit" className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-medium">{submitLabel}</button>
        </div>
      </form>
    </div>
  );
};

export default WithdrawalForm;
